// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Grid,
  Image,
  Input,
  Message,
  Modal,
  Popconfirm,
  Radio,
  Rate,
  Select,
  Space,
  Table,
  TableColumnProps,
  Tag,
  Upload
} from '@arco-design/web-react';
import dayjs from 'dayjs';

import './index.scss';

import { get, post } from '../requestNew';
import { baseUrl } from '../utils';
import { Item, SectorItem, StockItem } from './types';

const RadioGroup = Radio.Group;
const Option = Select.Option;
const { MonthPicker } = DatePicker;
const URL_UPLOAD = baseUrl + '/common/uploadFile';

const FormItem = Form.Item;
const TextArea = Input.TextArea;

const formItemLayout = {
  labelCol: {
    span: 0
  },
  wrapperCol: {
    span: 24
  }
};

function EventManagement() {
  const [form] = Form.useForm<Item>();
  const [formSearch] = Form.useForm<Item>();
  const [stockOptions, setStockOptions] = useState<[]>([]);
  const [sectorOptions, setSectorOptions] = useState<[]>([]);
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<Item[]>([]);

  const formRef = useRef<any>({});

  const columns: TableColumnProps[] = [
    {
      title: '封面图',
      dataIndex: 'coverImage',
      width: 80,
      fixed: 'left',
      render: text => {
        return <Image src={text} width={50} height={50} preview={true} style={{ borderRadius: 4 }} />;
      }
    },
    {
      title: '事件标题',
      width: 300,
      render: (_, record) => {
        return (
          <div>
            <div className="desc-title">{record.title}</div>
            <div className="desc-summary">{record.summary}</div>
          </div>
        );
      }
    },
    {
      title: '事件日期',
      width: 100,
      dataIndex: 'dateTitle'
    },
    {
      title: '排序时间',
      width: 100,
      dataIndex: 'eventDate'
    },
    {
      title: '事件时间范围',
      width: 200,
      render: (_, record) => {
        return record.startTime
          ? `${dayjs(record.startTime).format('MM月DD日')} - ${dayjs(record.endTime).format('MM月DD日')}`
          : '';
      }
    },
    {
      title: '关联板块',
      dataIndex: 'tags',
      width: 200,
      render: text => <Tag color="blue">#{text}</Tag>
    },
    {
      title: '关联度',
      dataIndex: 'starLevel',
      width: 200,
      render: text => <Rate allowHalf value={text} readonly />
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 100,
      render: text => (text === 1 ? <Tag color="green">已发布</Tag> : <Tag color="gray">草稿</Tag>)
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 120,
      fixed: 'right',
      render: (_, record: Item) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)}>
            编辑
          </Button>
          <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => del(record)}>
            <Button className="btn" type="text" status="danger">
              删除
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  const getList = (page?: { pageNum: number; pageSize: number }) => {
    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize,
      ...page
    };

    get<any>('/marketEvent/admin/page', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total);
          setDataList(list || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const getStock = () => {
    get<any>('/marketStock/admin/page', { pageSize: 100000, pageNum: 1 })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const list = (data?.list || []).map((item: StockItem) => {
            const { stockCode, stockName, id } = item;
            return { label: `${stockName}(${stockCode})`, value: id };
          });
          setStockOptions(list);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };
  const getSector = () => {
    get<any>('/marketSector/admin/page', { pageSize: 10000, pageNum: 1 })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const list = (data?.list || []).map((item: SectorItem) => {
            const { id, name } = item;
            return { label: name, value: id };
          });
          setSectorOptions(list);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const search = () => {
    setPageNum(1);
    setPageSize(20);
    const params = {
      pageNum: 1,
      pageSize: 20
    };
    getList(params);
  };

  const add = () => {
    formRef.current = {};
    form.resetFields();
    form.setFieldsValue({ status: 0, starLevel: 3, isTopCheck: false });
    setVisible(true);
  };
  const del = (record: Item) => {
    post(`/marketEvent/admin/delete?id=${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const edit = (record: Item) => {
    formRef.current = record;
    record.isTopCheck = record.isTop === 1;
    if (record.coverImage) {
      record.coverImageObj = {
        url: record.coverImage,
        uid: '-999',
        name: 'coverImage'
      };
    }
    if (record.detailImages) {
      record.detailImageObj = (record.detailImages || []).map((url: string, idx: number) => ({
        url,
        uid: `-${idx}`,
        name: 'detailImages'
      }));
    }
    record.timeRange = [record.startTime, record.endTime];
    record.sectorIds = (record.sectors || []).map((item: SectorItem) => item.id);
    record.stockIds = (record.conceptStocks || []).map((item: StockItem) => item.id);

    form.setFieldsValue({ ...record });
    setVisible(true);
  };
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };
  const onOk = () => {
    form.validate().then((values: Item) => {
      const { coverImageObj, detailImageObj, isTopCheck, timeRange, ...rest } = values;
      const data = {
        ...rest,
        isTop: isTopCheck ? 1 : 0,
        startTime: timeRange?.[0],
        endTime: timeRange?.[1]
      };

      if (coverImageObj) {
        data.coverImage = coverImageObj[0]?.response?.data || coverImageObj?.url;
      }
      if (detailImageObj) {
        data.detailImages = detailImageObj.map((item: any) => item?.response?.data || item?.url);
      }

      post('/marketEvent/admin/save', data)
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            getList();
            editCancel();
          } else {
            Message.error(message);
          }
        })
        .catch(e => {
          Message.error('网络错误!');
          console.log(e);
        });
    });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);
  useEffect(() => {
    getStock();
    getSector();
  }, []);

  return (
    <div className="event-management table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem field="month">
            <MonthPicker format="YYYY年M月" style={{ width: 140 }} allowClear placeholder="时间" />
          </FormItem>
          <FormItem field="starLevel">
            <Select placeholder="星级" allowClear style={{ width: 100 }}>
              <Option value={0.5}>0.5星</Option>
              <Option value={1}>1星</Option>
              <Option value={1.5}>1.5星</Option>
              <Option value={2}>2星</Option>
              <Option value={2.5}>2.5星</Option>
              <Option value={3}>3星</Option>
              <Option value={3.5}>3.5星</Option>
              <Option value={4}>4星</Option>
              <Option value={4.5}>4.5星</Option>
              <Option value={5}>5星</Option>
            </Select>
          </FormItem>
          <FormItem field="status">
            <Select placeholder="状态" allowClear style={{ width: 100 }}>
              <Option value={1}>已发布</Option>
              <Option value={0}>草稿</Option>
            </Select>
          </FormItem>
          <FormItem label="标签" field="tags">
            <Input placeholder="请输入标签" allowClear />
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={search}>
              查询
            </Button>
          </FormItem>
          {/* <FormItem>
            <Button type="outline" onClick={handleReset}>
              重置
            </Button>
          </FormItem> */}
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add}>
              新增摘要
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑事件' : '新增事件'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 900 }}
        className="event-management-modal"
        maskClosable={false}
      >
        <Form {...formItemLayout} form={form}>
          <FormItem field="id" hidden>
            <Input />
          </FormItem>
          <FormItem className="arco-form-item-title">
            <Grid.Row gutter={8}>
              <Grid.Col span={12}>
                事件标题
                <span className="red-star" />
              </Grid.Col>
              <Grid.Col span={12}>
                事件日期
                <span className="red-star" />
              </Grid.Col>
            </Grid.Row>
          </FormItem>
          <FormItem>
            <Grid.Row gutter={8}>
              <Grid.Col span={12}>
                <FormItem field="title" rules={[{ required: true, message: '请输入事件标题' }]}>
                  <Input placeholder="请输入事件标题" />
                </FormItem>
              </Grid.Col>
              <Grid.Col span={12}>
                <FormItem field="dateTitle" rules={[{ required: true, message: '请输入事件日期' }]}>
                  <Input placeholder="请输入事件日期" />
                </FormItem>
              </Grid.Col>
            </Grid.Row>
          </FormItem>
          <FormItem className="arco-form-item-title">
            <Grid.Row gutter={8}>
              <Grid.Col span={12}>
                排序日期
                <span className="red-star" />
              </Grid.Col>
              <Grid.Col span={12}>主线关联度</Grid.Col>
            </Grid.Row>
          </FormItem>
          <FormItem>
            <Grid.Row gutter={8}>
              <Grid.Col span={12}>
                <FormItem field="eventDate" rules={[{ required: true, message: '请选择日期' }]}>
                  <DatePicker placeholder="请选择日期" />
                </FormItem>
              </Grid.Col>
              <Grid.Col span={12}>
                <FormItem field="starLevel">
                  <Rate allowHalf />
                </FormItem>
              </Grid.Col>
            </Grid.Row>
          </FormItem>

          <FormItem className="arco-form-item-title">
            <Grid.Row gutter={8}>
              <Grid.Col span={6}>封面管理</Grid.Col>
              <Grid.Col span={18}>详情管理</Grid.Col>
            </Grid.Row>
          </FormItem>
          <FormItem>
            <Grid.Row gutter={8}>
              <Grid.Col span={6}>
                <FormItem field="coverImageObj" triggerPropName="fileList">
                  <Upload
                    action={URL_UPLOAD}
                    headers={{
                      Authorization: `${localStorage.getItem('authToken')}`
                    }}
                    imagePreview
                    listType="picture-card"
                    multiple={false}
                    accept="image/*"
                  />
                </FormItem>
              </Grid.Col>
              <Grid.Col span={18}>
                <FormItem field="detailImageObj" triggerPropName="fileList">
                  <Upload
                    action={URL_UPLOAD}
                    headers={{
                      Authorization: `${localStorage.getItem('authToken')}`
                    }}
                    imagePreview
                    listType="picture-card"
                    multiple
                    accept="image/*"
                  />
                </FormItem>
              </Grid.Col>
            </Grid.Row>
          </FormItem>

          <FormItem className="arco-form-item-title">关联概念股</FormItem>
          <FormItem field="stockIds">
            <Select
              mode="multiple"
              placeholder="输入代码或名称搜索，回车添加"
              allowClear
              options={stockOptions}
              filterOption={(inputValue, option) => option.props.children.includes(inputValue)}
            ></Select>
          </FormItem>

          <FormItem className="arco-form-item-title">关联板块</FormItem>
          <FormItem field="sectorIds">
            <Select
              mode="multiple"
              placeholder="输入板块名称，回车快捷添加"
              allowClear
              options={sectorOptions}
              filterOption={(inputValue, option) => option.props.children.includes(inputValue)}
            ></Select>
          </FormItem>

          <FormItem className="arco-form-item-title">
            摘要
            <span className="red-star" />
          </FormItem>
          <FormItem field="summary" rules={[{ required: true, message: '请输入摘要内容' }]}>
            <TextArea placeholder="请输入摘要内容" rows={5} />
          </FormItem>

          <FormItem className="arco-form-item-title">
            <Grid.Row gutter={8}>
              <Grid.Col span={12}>标签</Grid.Col>
              <Grid.Col span={12}>事件时间范围</Grid.Col>
            </Grid.Row>
          </FormItem>
          <FormItem>
            <Grid.Row gutter={8}>
              <Grid.Col span={12}>
                <FormItem field="tags">
                  <Input prefix="#" placeholder="请输入标签" />
                </FormItem>
              </Grid.Col>
              <Grid.Col span={12}>
                <FormItem field="timeRange">
                  <DatePicker.RangePicker style={{ width: '100%' }} />
                </FormItem>
              </Grid.Col>
            </Grid.Row>
          </FormItem>

          <FormItem>
            <Grid.Row gutter={8}>
              <Grid.Col span={12}>
                <FormItem field="status">
                  <RadioGroup type="button">
                    <Radio value={1}>已发布</Radio>
                    <Radio value={0}>草稿</Radio>
                  </RadioGroup>
                </FormItem>
              </Grid.Col>
              <Grid.Col span={12}>
                <FormItem field="isTopCheck" triggerPropName="checked">
                  <Checkbox>置顶展示</Checkbox>
                </FormItem>
              </Grid.Col>
            </Grid.Row>
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default EventManagement;
